<template>
    <div class="app-lang d-none d-sm-flex">
        <v-btn
            class="lang-btn"
            text
            :disabled="isActiveLang('ua')"
            @click="changeLang('ua')"
        >
            UA
        </v-btn>
        <v-divider
            vertical
        ></v-divider>
        <v-btn
            class="lang-btn"
            text
            :disabled="isActiveLang('ru')"
            @click="changeLang('ru')"
        >
            RU
        </v-btn>
    </div>
</template>

<script>
    export default {
        name: "Language",
        props:['textColor'],
        computed:{
            linkColor() {
                return this.textColor || 'orange--text text--lighten-2';
            }
        },
        methods: {
            isActiveLang(lang) {
                return this.$store.getters.language.appLanguage === lang;
            },
            changeLang(lang){
                const path = this.stripLocale(window.location.pathname.split('/'));
                const prefix = this.$store.getters.language.prefixes[lang];
                window.location.href = window.location.origin + prefix + path;
            },
            stripLocale(path) {
                path.shift();
                if( this.$store.getters.language.appLanguage !== 'ua')
                    path.shift();
                return path.join('/')
            }
        },
    }
</script>

<style scoped>
    a {
        margin: 0 3px;
    }

    .app-lang {
        padding: 0 3%;
    }

    .active-lang {
        opacity: 0.5;
    }
    .lang-btn {
        min-width: 43px !important;
        padding: 0 5px !important;
    }
</style>
